import collectionSummaryServices from '../services/reportDownloadServices';
import {COLLECTION_DETAILS_SUCCESS,COLLECTION_DETAILS_REQUEST,COLLECTION_SUMMARY_REQUEST,COLLECTION_SUMMARY_SUCCESS,SERVICE_REVENUE_REQUEST,SERVICE_REVENUE_SUCCESS, BILL_SUMMARY_REQUEST, BILL_SUMMARY_SUCCESS, BILL_REVENUE_SUCCESS, BILL_REVENUE_REQUEST, CATEGORY_LIST_SUCCESS, CATEGORY_LIST_REQUEST, DOCTOE_REPORT_REQUEST, DOCTOE_REPORT_SUCCESS, BACKUP_DOWNLOAD_SUCCESS} from "../../shared/constants";


// export function getCollectionSummary(data,resCb){
//     return (dispatch) => {
//         dispatch(request(COLLECTION_SUMMARY, {}));
//         collectionSummaryServices.getUserCollectionSummary(data).then(
//             (res) => {
//               console.log(res);
//               if (res) {
//                 dispatch(success(COLLECTION_SUMMARY, res.data));
//               }
//               resCb(res.data);
//             },
//             (error) => {
//               resCb(error.toString);
//             }
//         );
//     };

// }


export function getCollectionSummary(data, resCb) {
  return (dispatch) => {
    dispatch({ type: COLLECTION_SUMMARY_REQUEST });

    collectionSummaryServices.getUserCollectionSummary(data).then(
      (res) => {
        dispatch({
          type: COLLECTION_SUMMARY_SUCCESS,
          payload: res
        });
        resCb(res);
      },
      (error) => {
        resCb(error.toString());
      }
    );
  };
}


export function getCollectionDetails(data, resCb) {
  return (dispatch) => {
    dispatch(request(COLLECTION_DETAILS_REQUEST, {}));

    collectionSummaryServices.getUserCollectionDetails(data).then(
      (res) => {
        const responseData = res?.data ?? res;
        dispatch(success(COLLECTION_DETAILS_SUCCESS, responseData));
        if (resCb) {
          resCb(responseData);
        }
      },
      (error) => {
        if (resCb) {
          resCb(error?.toString?.() || "Error fetching collection details");
        }
      }
    );
  };
}


export function getserviceRevenueReport(data, resCb) {
  return (dispatch) => {
    dispatch(request(SERVICE_REVENUE_REQUEST, {}));

    collectionSummaryServices.getserviceRevenueReport(data).then(
      (res) => {
        const responseData = res?.data ?? res;
        dispatch(success(SERVICE_REVENUE_SUCCESS, responseData));
        if (resCb) {
          resCb(responseData);
        }
      },
      (error) => {
        if (resCb) {
          resCb(error?.toString?.() || "Error fetching service revenue details");
        }
      }
    );
  };
}

export function getBillSummaryReport(data, resCb) {
  return (dispatch) => {
    dispatch(request(BILL_SUMMARY_REQUEST, {}));

    collectionSummaryServices.getBillSummaryReport(data).then(
      (res) => {
        const responseData = res?.data ?? res;
        dispatch(success(BILL_SUMMARY_SUCCESS, responseData));
        if (resCb) {
          resCb(responseData);
        }
      },
      (error) => {
        if (resCb) {
          resCb(error?.toString?.() || "Error fetching bill summary details");
        }
      }
    );
  };
}


export function getBillRevenueReport(data, resCb) {
  return (dispatch) => {
    dispatch(request(BILL_REVENUE_REQUEST, {}));

    collectionSummaryServices.getBillRevenueReport(data).then(
      (res) => {
        const responseData = res?.data ?? res;
        dispatch(success(BILL_REVENUE_SUCCESS, responseData));
        if (resCb) {
          resCb(responseData);
        }
      },
      (error) => {
        if (resCb) {
          resCb(error?.toString?.() || "Error fetching bill revenue details");
        }
      }
    );
  };
}


export function getDoctorServiceReport(data, resCb) {
  return (dispatch) => {
    dispatch(request(DOCTOE_REPORT_REQUEST, {}));

    collectionSummaryServices.getDoctorReport(data).then(
      (res) => {
        const responseData = res?.data ?? res;
        dispatch(success(DOCTOE_REPORT_SUCCESS, responseData));
        if (resCb) {
          resCb(responseData);
        }
      },
      (error) => {
        if (resCb) {
          resCb(error?.toString?.() || "Error fetching DOCTOR REPORT details");
        }
      }
    );
  };
}

export function getCategoryList(data, resCb) {
  return (dispatch) => {
    dispatch(request(CATEGORY_LIST_REQUEST, {}));

    collectionSummaryServices.getCategoryList(data).then(
      (res) => {
        const responseData = res?.data ?? res;
        dispatch(success(CATEGORY_LIST_SUCCESS, responseData));
        if (resCb) {
          resCb(responseData);
        }
      },
      (error) => {
        if (resCb) {
          resCb(error?.toString?.() || "Error fetching category details");
        }
      }
    );
  };
}

export function downloadBackup(data, resCb) {
  return (dispatch) => {
    collectionSummaryServices.downloadBackup(data).then(
      (res) => {
        const responseData = res?.data ?? res;
        dispatch(success(BACKUP_DOWNLOAD_SUCCESS, responseData));
        if (resCb) {
          resCb(responseData);
        }
      },
      (error) => {
        if (resCb) {
          resCb(error?.toString?.() || "Error fetching category details");
        }
      }
    );
  };
}

export function getPatientJourneyReport(data, resCb) {
  return (dispatch) => {
    dispatch(request("PATIENT_JOURNEY_REQUEST", {}));
    collectionSummaryServices.getPatientJourneyReport(data).then(
      (res) => {
        const responseData = res?.data ?? res;
        dispatch(success("PATIENT_JOURNEY_SUCCESS", responseData));
        if (resCb) resCb(responseData);
      },
      (error) => {
        if (resCb) resCb(error?.toString?.() || "Error fetching patient journey");
      }
    );
  };
}

function success(type, data) {
  return { type: type, payload: data };
}
function failure(type, value) {
  return { type: type, payload: value };
}
function request(type, value) {
  return { type: type, payload: value };
}


const collectionSummaryAction = {
getCollectionSummary,
getCollectionDetails,
getserviceRevenueReport,
getBillSummaryReport,
getBillRevenueReport,
getCategoryList,
downloadBackup,
getDoctorServiceReport
};


export default collectionSummaryAction;
